define('numeric-input',['lib/event-emitter', 'longpress-button'], function(EventEmitter, longpressButton) {
	/**
	 * Initializes a numeric input element
	 * @param input the jQuery object to the <input> element
	 */
	function NumericInput(input) {
		EventEmitter.call(this);
		
		input = input || $('<input type="text">');
		
		this.value = 0;
		this.step = 1;
		this.min = 0;
		this.max = 1e6;
		
		this._disableChangeEvents = false;
		
		this.input = input;
		this.upButton = $('<button class="numeric-up-button" type="button" tabindex="-1">+</button>');
		this.downButton = $('<button class="numeric-down-button" type="button" tabindex="-1">-</button>');
		this.element = $('<div>')
			.insertAfter(input)
			.addClass('numeric-input')
			.append(input, this.upButton, this.downButton);

		// long-pressing the buttons should trigger them at intervals
		longpressButton.make(this.upButton);
		longpressButton.make(this.downButton);
		
		this.element.find('button').on('focus', function() {
			this.input.focus();
		}.bind(this));
		
		this.upButton.on('tick', function() {
			var newValue = this._getCleanedUpInputValue() + this.step;
			if (newValue > this.max)
				newValue = this.max;
			this._setInputValue(newValue);
			this.emit('peek', newValue);
		}.bind(this));

		this.downButton.on('tick', function() {
			var newValue = this._getCleanedUpInputValue() - this.step;
			if (newValue < this.min)
				newValue = this.min;
			this._setInputValue(newValue);
			this.emit('peek', newValue);
		}.bind(this));
		
		this.element.find('button').on('up', function() {
			this._applyInputValue(); // do not update at every tick, but when button is released
		}.bind(this));

		this.input.on('keyup keydown keypress change', function(e) {
			if (e.which == 13) { // enter pressed
				e.preventDefault(); // do not submit form
				
				// only apply if valid to let the user fix it
				if (this.isValid())
					this._applyValue(parseInt(this.input.val()));
				
				this.input.select();
				
				return;
			}
			
			if (this._disableChangeEvents)
				return;
			this.input.toggleClass('invalid', !this.isValid());
		}.bind(this));
		
		// up/down keys should change the value
		this.input.on('keydown', function(e) {
			if (e.which == 38 /* up */)
				this.upButton.manualDown();
			else if (e.which == 40 /* down */)
				this.downButton.manualDown();
			else
				return;
			e.stopPropagation();
			e.preventDefault();
		}.bind(this));
		
		this.input.on('keyup', function(e) {
			if (e.which == 38 /* up */)
				this.upButton.manualUp();
			else if (e.which == 40 /* down */)
				this.downButton.manualUp();
			else
				return;
			e.stopPropagation();
			e.preventDefault();
		}.bind(this));
		
		/**
		 * Focus is lost and value has changed 
		 */
		this.input.on('change', function() {
			if (!this._disableChangeEvents)
				this._applyInputValue();
		}.bind(this));
	}
	
	NumericInput.prototype = Object.create(EventEmitter.prototype);
	
	/**
	 * Sets the value in the input field without affecting the .value property
	 */
	NumericInput.prototype._setInputValue = function(newValue) {
		this._disableChangeEvents = true;
		this.input.val(newValue);
		this._disableChangeEvents = false;
	};
	
	NumericInput.prototype.setValue = function(newValue) {
		this.value = newValue;
		this._setInputValue(newValue);
	};
	
	NumericInput.prototype.isValid = function() {
		var parsed = parseIntStrictly(this.input.val());
		return isFinite(parsed) && parsed >= this.min && parsed <= this.max;
	};
	
	NumericInput.prototype._getCleanedUpInputValue = function() {
		var newValue = parseIntStrictly(this.input.val());
		
		// if it's not even a finite number, simply reset to the old value
		if (!isFinite(newValue))
			return this.value;
		else if (newValue < this.min) // try to recover
			return this.min;
		else if (newValue > this.max)
			return this.max;
		else
			return newValue;
	};
	
	NumericInput.prototype._applyInputValue = function() {
		var newValue = this._getCleanedUpInputValue();
		this._applyValue(newValue);

		// now it's definitly valid again
		this.input.removeClass('invalid');
	};
	
	NumericInput.prototype._applyValue = function(newValue) {
		var hasChanged = newValue != this.value;
		
		// always update view, because this.value and input.val() may have diverged by user input
		this.setValue(newValue);
		
		// only fire event if value has actually changed
		if (hasChanged)
			this.emit('change', this.value);
	};
	
	NumericInput.prototype.setWidth = function(width) {
		this.input.outerWidth(width);
	};
	
	function parseIntStrictly(value) {
		if(/^(\-|\+)?([0-9]+)$/.test(value))
			return Number(value);
		return NaN;
	}

	return NumericInput;
});

